import React from 'react';
import styled from 'styled-components';

const MenuWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0 24px;
  line-height: 40px;

  ul.ant-menu {
    border-bottom: 0;
    > .ant-menu-item,
    .ant-menu-submenu {
      border-radius: ${props => props.theme.borderRadius}px;
      margin-right: 4px;
    }
    .ant-menu-item:hover,
    .ant-menu-submenu:hover {
      background-color: ${props => props.theme.colorBgTextHover};
    }
    .ant-menu-item-selected,
    .ant-menu-item-selected:hover,
    .ant-menu-submenu-selected,
    .ant-menu-submenu-selected:hover {
      background-color: ${props => props.theme.controlItemBgActive};
    }
  }
`;

export interface IMainMenuWrapperProps {
  children?: React.ReactNode;
}

export function MainMenuWrapper(props: IMainMenuWrapperProps) {
  return <MenuWrapper>{props.children}</MenuWrapper>;
}
